module.exports = {"payments":[{"name":"Cash","value":"cash"},{"name":"Check","value":"check"},{"name":"Credit Card","value":"card"},{"name":"VIPatron","value":"vipatron"},{"name":"Reserve/Block","value":"reserved"},{"name":"Bulk Ticket","value":"bulk"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/PaymentOptions/locales/en.json
// module id = 1146
// module chunks = 0